module.exports = __webpack_public_path__ + "static/img/active_07.757d165.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/survey2/images/activity/active_07.jpg
// module id = ohJH
// module chunks = 0